/**
 * The Product analytics address's pick-several filters: a comma-separated
 * list where absent means all and `none` means none.
 */

/**
 * Why the shopper came, as the server reads it: the conversation's label, else
 * its topic's rule. Pre-purchase is the stored `shopping`, post-purchase `support`.
 */
export type VisitReason = "pre" | "post" | "other" | "unrecorded";

export const VISIT_REASONS: readonly VisitReason[] = ["pre", "post", "other", "unrecorded"];

/**
 * The widget layout recorded on the conversation, as the server stores it:
 * phone below 768px, tablet from 768px, desktop from 1000px, or none.
 */
export type DeviceChoice = "phone" | "tablet" | "desktop" | "unrecorded";

export const DEVICE_CHOICES: readonly DeviceChoice[] = ["phone", "tablet", "desktop", "unrecorded"];

/** A comma-separated list in the address: absent means all, `none` means none. */
export function choiceList<T extends string>(raw: unknown, allowed: readonly T[]): T[] {
  if (raw === "none") return [];
  const words = typeof raw === "string" ? raw.split(",") : [];
  const picked = allowed.filter((word) => words.includes(word));
  return picked.length > 0 ? picked : [...allowed];
}

/** The address form of a list: left out when it keeps everything. */
export function choiceListParam<T extends string>(
  values: readonly T[],
  allowed: readonly T[],
): string | undefined {
  if (values.length === allowed.length) return undefined;
  return values.length === 0 ? "none" : values.join(",");
}
